import { render, staticRenderFns } from "./PackingOrder.vue?vue&type=template&id=012a049e"
import script from "./PackingOrder.vue?vue&type=script&lang=js"
export * from "./PackingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports